/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { memo } from 'react';
// import classnames from 'classnames';
import { Layout, Row, Col } from 'antd';
import './style.scss';
import { useSelector } from 'react-redux';
import styles from './styles.module.css';
// import BackTop from 'antd/es/back-top';
import { longanURL, supportURL } from '../../utils/index';
function Footer() {
  const userInfo = useSelector((state) => state.userInfo);
  const token = useSelector((state) => state.token);
  const copyright = `Copyright © ${new Date().getFullYear()} 广东英荔国际教育科技有限公司 `;
  const logoUrl = '/image/footer_logo.png';
  const isStudent = userInfo && userInfo.user_type === 'student';

  const studentFooter = () => {
    return (
      <div className={styles.studentContainer} data-testid="test-footer">
        <div className={styles.footerMsg}>
          <div className={styles.studentLogo}>
            <img className={styles.logoimage} src={logoUrl} alt="Longan" />
          </div>
          <div className={styles.gutterWrap}>
            <div className={styles.gutterItem}>
              <a
                href={`${supportURL}/%E8%8B%B1%E8%8D%94%E6%95%99%E5%AD%A6%E4%BA%91%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                用户协议
              </a>
            </div>
            <div className={styles.gutterItem}>
              <a
                href={`${supportURL}/%E8%8B%B1%E8%8D%94%E6%95%99%E5%AD%A6%E4%BA%91%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                隐私条款
              </a>
            </div>
            <div className={styles.gutterItem}>
              <a
                href="https://wj.qq.com/s2/7173869/e431/"
                rel="noopener noreferrer"
                target="_blank"
              >
                进阶学习
              </a>
            </div>
            <div className={styles.gutterItem}>
              <a
                href="https://support.aimaker.space/"
                rel="noopener noreferrer"
                target="_blank"
              >
                联系我们
              </a>
            </div>
          </div>
        </div>
        <div className={styles.copyrightWrapper}>
          <div className={styles.copyright}>
            {copyright}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={'http://www.beian.miit.gov.cn/ '}
            >
              粤 ICP 备 13044168 号-9
            </a>
          </div>
        </div>
        <div className={styles.footerBorder}></div>
      </div>
    );
  };
  return (
    <Layout.Footer>
      {/* <BackTop /> */}
      {isStudent ? (
        studentFooter()
      ) : (
        <React.Fragment>
          <div className="techerContainer">
            <Row gutter={16} className="ant-row-footer">
              <Col
                className="gutter-row"
                xs={{ span: 24 }}
                lg={{ span: 4 }}
                style={{ paddingLeft: 0 }}
              >
                <img className={styles.logo} src={logoUrl} alt="Longan" />
              </Col>
              <Col className="gutter-row" xs={{ span: 24 }} lg={{ span: 4 }}>
                <ul>
                  <li>
                    <a
                      href={`${longanURL}/about`}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      关于我们
                    </a>
                  </li>

                  <li>
                    <a
                      href={`${supportURL}/%E8%8B%B1%E8%8D%94%E6%95%99%E5%AD%A6%E4%BA%91%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      隐私条款
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${supportURL}/%E8%8B%B1%E8%8D%94%E6%95%99%E5%AD%A6%E4%BA%91%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE/`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      用户协议
                    </a>
                  </li>
                </ul>
              </Col>
              <Col className="gutter-row" xs={{ span: 24 }} lg={{ span: 4 }}>
                <ul>
                  {token && (
                    <>
                      <li>
                        <a
                          // href={`${longanURL}/course/38/0/`}
                          href="https://course.aimaker.space/course/38/0/"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          使用帮助
                        </a>
                      </li>
                        {
                          !isStudent && <li>
                            <a
                              href="https://competition.aimaker.space/"
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              赛事活动
                            </a>
                          </li>
                        }
                    </>
                  )}

                  <li>
                    <a
                      href={supportURL}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      联系我们
                    </a>
                  </li>
                </ul>
              </Col>
              {/* <Col
                className="gutter-row"
                xs={{ span: 24 }}
                lg={{ span: 8 }}
              ></Col> */}

              <Col
                className={['gutter-row', styles.qrCodeWrap].join(' ')}
                xs={{ span: 24 }}
                lg={{ span: 12 }}
              >
                <div className={styles.qrcodeTitle}>
                  {userInfo?.organization_data?.image_mark && (
                    <img
                      src={userInfo?.organization_data?.image_mark}
                      alt=""
                      className={styles.qrcodeImg}
                    />
                  )}
                  {userInfo?.organization_data?.text_mark && (
                    <p>{userInfo?.organization_data?.text_mark}</p>
                  )}
                </div>
              </Col>
            </Row>
            <div className={styles.copyrightWrapper}>
              <div className="copyright">
                {copyright}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={'https://beian.miit.gov.cn/'}
                >
                  粤 ICP 备 13044168 号-9
                </a>
              </div>
            </div>
            <div className={styles.footerBorder}></div>
          </div>
        </React.Fragment>
      )}
    </Layout.Footer>
  );
}

export default memo(Footer);
